import { useState } from "react";

import { Button } from "@/components/ui/button";
import { CustomModelPriceDialog } from "@/components/CustomModelPriceDialog";

export const AddCustomModelPriceAction = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="outline" className="flex items-center gap-2" onClick={() => setOpen(true)}>
        Add custom price
      </Button>
      <CustomModelPriceDialog open={open} onOpenChange={setOpen} />
    </>
  );
};
